import React from "react";
import Topbar from "./Topbar";

export default function Layout({ children }) {
  return (
    <div className="">
      <Topbar />

      <div className="layout-main-container">
        <div className="layout-main ">{children}</div>
      </div>
    </div>
  );
}
